module.exports = __webpack_public_path__ + "static/video-a1bf5eb289faf0ebe0a000c12cb7ff9c.mp4";